import { gql } from '../generated/cache';

export const allSupportedAssets = gql(/* GraphQL */ `
  query getAllSupportedAssets {
    assets: allSupportedAssets {
      nodes {
        id
      }
    }
  }
`);

export const getOraclePricesQuery = gql(/* GraphQL */ `
  query GetOraclePrices {
    prices: allOraclePrices {
      nodes {
        price
        baseAsset
      }
    }
  }
`);
